import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SearchService } from '../../services/search/search.service';
import { TokenStorage } from '../../auth/token.storage';

import {
  MatDialog, MatDatepickerInputEvent
} from '@angular/material';
import { OrderService } from 'src/app/services/order/order.service';
import { NotifierService } from 'angular-notifier';
import { DialogConfirm } from '../schedulingandplanning/edittripmodal/edittripmodal.component';
import { ImagePopup } from '../order/allorderdetails/allorderdetails.component';
import { BranchService } from 'src/app/services/branch/branch.service';
import { forkJoin } from 'rxjs';




@Component({
  selector: 'app-searchresult',
  templateUrl: './searchresult.component.html',
  styleUrls: ['./searchresult.component.scss']
})
export class SearchresultComponent implements OnInit {

  searchText: string;
  searchOption: string;
  noResult: boolean = false;
  orderLength: number;
  searchResult = [];
  displayedColumns: string[] = ['productDetails', 'qty', 'serialNos'];
  productDataArray = [];
  isBajaj: boolean = false;
  isBajajTest: boolean = false;
  deliveryFailureReason: string;
  isRescheduled: boolean = true;
  minDate: Date;
  rescheduleDate: string;
  podList = []
  isPodClicked: boolean = false;
  allBranchesNames = [];
  schedulebillProductArray = [];
  isScheduleBillButtonDisable = false;
  isWarningQuantity: boolean = false;
  disableScheduleButton: boolean = false;
  fetchingPODs: boolean = false;
  eSignAvailable: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private searchService: SearchService,
    private token: TokenStorage,
    private orderService: OrderService,
    private notifierService: NotifierService,
    private dialog: MatDialog,
    private branchService: BranchService
  ) { }

  ngOnInit() {
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test')
      this.isBajaj = true;
    if (this.isBajaj) {
      this.isBajajTest = true;
      this.branchService.getAllBranches().subscribe(allBranches => {
        this.allBranchesNames = allBranches;
        this.allBranchesNames.sort(function (a, b) {
          let branchArea1 = a.branchName.toLowerCase(), branchArea2 = b.branchName.toLowerCase()
          if (branchArea1 < branchArea2)
            return -1
          if (branchArea1 > branchArea2)
            return 1
          return 0
        });
      });
    }
    this.activatedRoute.params.subscribe((param: Params) => {
      this.searchText = param['searchText'];
      this.searchOption = param['searchOption'];

      this.searchData(this.searchText, this.searchOption);

    });
    this.minDate = new Date();
  }
  searchData(searchText, searchOption) {
    this.schedulebillProductArray = [];
    this.searchService.search(searchText, searchOption).subscribe(searchResult => {
      this.disableScheduleButton = false;
      this.searchResult = searchResult;
      console.log("searchResult", searchResult);
      this.productDataArray = [];
      if (searchResult.length < 1) {
        this.noResult = true;
      }
      this.searchResult = searchResult;
      this.orderLength = searchResult.length;

      for (let i = 0; i < searchResult.length; i++) {
        if (searchResult[i].orderInfo.oState === 'ORDER_STATE_DELIVERED') {
          this.searchResult[i].isDelivered = true;
        }
        else
          this.searchResult[i].isDelivered = false;

        this.productDataArray[i] = searchResult[i].prodQList;
        this.productDataArray[i].oState = searchResult[i].orderInfo.oState;
        this.productDataArray[i].orderUniqueId = searchResult[i].orderInfo.orderUniqueId;
        this.productDataArray[i].orderInvoiceNumber = searchResult[i].orderInfo.orderInvoiceNumber;
        if (searchResult[i].orderInfo.oState === "ORDER_STATE_FAILED") {
          this.orderService.getJobDetails(searchResult[i].orderInfo.orderUniqueId).subscribe(jobRes => {
            this.deliveryFailureReason = jobRes.reason;
          });
        }
      }
      this.noResult = false;


    }, Error => {
      console.log(Error);
      this.noResult = true;
    })
  }

  openImage(image) {
    const dialogR = this.dialog.open(ImagePopup, {
      data: image
    });
    dialogR.updatePosition({
      top: '74px'
    });
  }


  stateChange(orderId, event) {
    if (event.value == 'deliveryfromwarehouse' || event.value == 'deliveryfromstore') {
      let dialogConfirm;
      if (event.value == 'deliveryfromwarehouse') {
        dialogConfirm = this.dialog.open(DialogConfirm, {
          width: '300px',
          data: "Do you want to schedule this order for delivery from warehouse?"
        });
      }

      else if (event.value == 'deliveryfromstore') {
        dialogConfirm = this.dialog.open(DialogConfirm, {
          width: '300px',
          data: "Do you want to schedule this order for delivery from store?"
        });
      }

      dialogConfirm.afterClosed().subscribe(result => {
        if (result) {
          this.orderService.orderStateChange(orderId, 'ORDER_STATE_UNPLANNED').subscribe(() => {
            this.notifierService.notify("success", "Order Scheduled For Delivery Successfully");
            this.ngOnInit();
          });
        }
      });
    }
    if (event.value == 'customerpickup') {
      let dialogConfirm = this.dialog.open(DialogConfirm, {
        width: '300px',
        data: "Do you want to schedule this order for delivery for customer pickup?"
      });

      dialogConfirm.afterClosed().subscribe(result => {
        if (result) {
          this.orderService.orderStateChange(orderId, 'ORDER_STATE_SCHEDULED_FOR_PICKUP').subscribe(() => {
            this.notifierService.notify("success", "Order Scheduled For Delivery Successfully");
            this.ngOnInit();
          });
        }
      });
    }
  }

  stopEnter(event) {
    if (event.which === 13) {
      event.preventDefault();
    }
  }

  changeSerialNum(event, oid, pid) {
    let pList = [], finalSerialNum = [];
    event.preventDefault();
    event.stopPropagation();
    if (event.keyCode == '13' && event.target.textContent.split(',')[0] != ' - ') {
      let serialno = event.target.textContent.split(',');
      let isInvalid: boolean = false;
      serialno.forEach(element => {
        element = element.replace(/\s/g, '');
        finalSerialNum.push(element);
        if (element == '') {
          isInvalid = true;
        }
      });
      if (isInvalid)
        this.notifierService.notify("error", "Only Spaces Entered In Serial Number.");
      else if (!isInvalid) {
        let orderToSend = []
        this.searchResult.forEach(order => {
          if (order.orderInfo.orderUniqueId == oid && order.isDelivered) {
            pList = order.prodQList;
            pList.forEach(product => {
              if (product.product.productId == pid)
                product.deliveredProductSerialNumbers = finalSerialNum;
            })
            orderToSend.push(order)
          }
        })
        if (orderToSend.length > 0) {
          this.orderService.changeProductSerialNumber(orderToSend).subscribe(changedSerialNumber => {
            this.notifierService.notify("success", "Serial Number Changed Successfully.");
          }, Error => {
            console.log(Error);
            this.notifierService.notify("error", Error.error.Result);
          })
        }
      }
    }
  }

  // getPODImageLinks(order) {
  //   this.fetchPODLoading = true;
  //   this.orderService.podImageData(order.orderInfo.orderUniqueId).subscribe(res => {
  //     this.isPodClicked = true;
  //     this.podList = res;
  //     this.fetchPODLoading = false;
  //     this.orderService.eSignImage(order.orderInfo.orderUniqueId).subscribe(esign => {
  //       if (esign && esign[0])
  //         this.podList.push(esign[0]);
  //     });
  //   });
  //   this.fetchPODLoading = false;
  // }
//Method updated by Digvijay for adding loader
  getPODImageLinks(order) {
    this.fetchingPODs = true;
  
    const podImage$ = this.orderService.podImageData(order.orderInfo.orderUniqueId);
    const eSignImage$ = this.orderService.eSignImage(order.orderInfo.orderUniqueId);
  
    forkJoin([podImage$, eSignImage$]).subscribe(([podRes, esignRes]) => {
      this.isPodClicked = true;
      this.podList = podRes || [];
  
      if (esignRes && esignRes.length > 0) {
        this.eSignAvailable = true;
        this.podList.push(esignRes[0]);
      }
  
      this.fetchingPODs = false;
    }, error => {
      console.error('Error fetching POD or eSign:', error);
      this.fetchingPODs = false;
    });
  }
  
  deliveryDateChange(event: MatDatepickerInputEvent<Date>) {
    if (event) {
      (event.value).setHours(0, -(event.value).getTimezoneOffset(), 0, 0);
      this.rescheduleDate = ((event.value).toISOString()).slice(0, -5);
      this.isRescheduled = !this.isRescheduled;
    } else {
      this.notifierService.notify('error', "Error..");
    }
  }

  rescheduleOrder(orderInvoiceNumber, remarks: string) {
    this.orderService.rescheduleOrder(orderInvoiceNumber, this.rescheduleDate).subscribe(res => {
      this.notifierService.notify('success', "Order rescheduled and ready for planning.");
    }, error => {
      this.notifierService.notify('error', "Error rescheduling order.");
    });
  }
  markAsDelivered(orderId) {
    this.orderService.adminDeliverOrder(orderId).subscribe(res => {
      this.notifierService.notify('success', "Order marked as delivered.");
      location.reload();
    }, error => {
      this.notifierService.notify('error', "Order failed to marked as delivered.");
    });
  }

  quantityChange(event, element, from, order) {
    let ind = this.schedulebillProductArray.findIndex(prod => prod.productId == element.product.productId && prod.orderType == from);
    if (event.srcElement.value > element.productQuantity || event.srcElement.value < 0 || Number(element.value1) < 0 || Number(element.value2) < 0 || Number(element.value3) < 0) {
      element.isScheduleBillButtonDisable = true;
      element.isWarningQuantity = true;
    }
    else {
      if (Number(element.value1) + Number(element.value2) + Number(element.value3) < 0) {
        element.isScheduleBillButtonDisable = true;
        element.isWarningQuantity = true;
      }
      else if (element.productQuantity > Number(element.value1) + Number(element.value2) + Number(element.value3)) {
        element.isScheduleBillButtonDisable = false;
        element.isWarningQuantity = true;
      }
      else if (element.productQuantity < Number(element.value1) + Number(element.value2) + Number(element.value3)) {
        element.isScheduleBillButtonDisable = true;
        element.isWarningQuantity = true;
      }
      else {
        element.isScheduleBillButtonDisable = false;
        element.isWarningQuantity = false;
      }

      if (this.schedulebillProductArray[ind]) {
        this.schedulebillProductArray[ind].productQuantity = event.srcElement.value;
      }
    }

    this.schedulebillProductArray.forEach(product => {
      if (product.productId == element.product.productId) {
        product.isScheduleBillButtonDisable = element.isScheduleBillButtonDisable;
        product.isWarningQuantity = element.isWarningQuantity;
      }
    })

    if (this.schedulebillProductArray.find(prod => prod.isScheduleBillButtonDisable == true))
      this.isScheduleBillButtonDisable = true;
    else
      this.isScheduleBillButtonDisable = false;

    if (this.schedulebillProductArray.find(prod => prod.isWarningQuantity == true))
      this.isWarningQuantity = true;
    else
      this.isWarningQuantity = false
    order.prodQList.forEach(product => {
      if (Number(product.value1) + Number(product.value2) + Number(product.value3) == 0) {
        this.isWarningQuantity = true;
      }
    })
  }

  setDeliveryType(event, element, order) {
    let ind = this.schedulebillProductArray.findIndex(prod => prod.productId == element.product.productId && prod.orderType == event.source.value)
    if (!event.checked && event.source.value == 'ORDER_TYPE_DELIVERY') {
      element.isDeliveryFromWarehouse = false;
      element.value1 = 0;
    }
    else if (!event.checked && event.source.value == 'ORDER_TYPE_STORE_PICKUP') {
      element.isCustomerPickup = false;
      element.value2 = 0;
    }
    else if (!event.checked && event.source.value == 'ORDER_TYPE_STORE_DELIVERY') {
      element.isDeliveryFromStore = false;
      element.value3 = 0;
    }

    if (Number(element.value1) + Number(element.value2) + Number(element.value3) < 0) {
      element.isScheduleBillButtonDisable = true;
      element.isWarningQuantity = true;
    }
    else if (element.productQuantity > Number(element.value1) + Number(element.value2) + Number(element.value3)) {
      element.isScheduleBillButtonDisable = false;
      element.isWarningQuantity = true;
    }
    else if (element.productQuantity < Number(element.value1) + Number(element.value2) + Number(element.value3)) {
      element.isScheduleBillButtonDisable = true;
      element.isWarningQuantity = true;
    }
    else {
      element.isScheduleBillButtonDisable = false;
      element.isWarningQuantity = false;
    }

    this.schedulebillProductArray.forEach(product => {
      if (product.productId == element.product.productId) {
        product.isScheduleBillButtonDisable = element.isScheduleBillButtonDisable;
        product.isWarningQuantity = element.isWarningQuantity;
      }
    })
    if (this.schedulebillProductArray.find(prod => prod.isScheduleBillButtonDisable == true))
      this.isScheduleBillButtonDisable = true;
    else
      this.isScheduleBillButtonDisable = false;

    if (this.schedulebillProductArray.find(prod => prod.isWarningQuantity == true))
      this.isWarningQuantity = true;
    else
      this.isWarningQuantity = false
    let bname = order.orderInfo.branchName;
    if (ind != -1) {
      bname = this.schedulebillProductArray[ind].branchName;
      this.schedulebillProductArray.splice(ind, 1)
    }
    if (event.checked) {

      if (event.source.value == 'ORDER_TYPE_DELIVERY') {
        element.isDeliveryFromWarehouse = true;
        this.schedulebillProductArray.push({
          orderType: 'ORDER_TYPE_DELIVERY',
          productId: element.product.productId,
          productQuantity: element.value1,
          branchName: bname,
          isWarningQuantity: element.isWarningQuantity,
          isScheduleBillButtonDisable: element.isScheduleBillButtonDisable
        })
      }
      if (event.source.value == 'ORDER_TYPE_STORE_PICKUP') {
        element.isCustomerPickup = true;
        this.schedulebillProductArray.push({
          orderType: 'ORDER_TYPE_STORE_PICKUP',
          productId: element.product.productId,
          productQuantity: element.value2,
          branchName: bname,
          isWarningQuantity: element.isWarningQuantity,
          isScheduleBillButtonDisable: element.isScheduleBillButtonDisable
        })
      }
      if (event.source.value == 'ORDER_TYPE_STORE_DELIVERY') {
        element.isDeliveryFromStore = true;
        this.schedulebillProductArray.push({
          orderType: 'ORDER_TYPE_STORE_DELIVERY',
          productId: element.product.productId,
          productQuantity: element.value3,
          branchName: bname,
          isWarningQuantity: element.isWarningQuantity,
          isScheduleBillButtonDisable: element.isScheduleBillButtonDisable
        })
      }

      if (Number(element.value1) + Number(element.value2) + Number(element.value3) < 0) {
        element.isScheduleBillButtonDisable = true;
        element.isWarningQuantity = true;
      }
      else if (element.productQuantity > Number(element.value1) + Number(element.value2) + Number(element.value3)) {
        element.isScheduleBillButtonDisable = false;
        element.isWarningQuantity = true;
      }
      else if (element.productQuantity < Number(element.value1) + Number(element.value2) + Number(element.value3)) {
        element.isScheduleBillButtonDisable = true;
        element.isWarningQuantity = true;
      }
      else {
        element.isScheduleBillButtonDisable = false;
        element.isWarningQuantity = false;
      }

      this.schedulebillProductArray.forEach(product => {
        if (product.productId == element.product.productId) {
          product.isScheduleBillButtonDisable = element.isScheduleBillButtonDisable;
          product.isWarningQuantity = element.isWarningQuantity;
        }
      })
      if (this.schedulebillProductArray.find(prod => prod.isScheduleBillButtonDisable == true))
        this.isScheduleBillButtonDisable = true;
      else
        this.isScheduleBillButtonDisable = false;

      if (this.schedulebillProductArray.find(prod => prod.isWarningQuantity == true))
        this.isWarningQuantity = true;
      else
        this.isWarningQuantity = false

    }
  }

  onSelectAssociatedUnit(event, element, from) {
    let ind = this.schedulebillProductArray.findIndex(prod => prod.productId == element.product.productId && prod.orderType == from)
    if (this.schedulebillProductArray[ind]) {
      this.schedulebillProductArray[ind].branchName = event.srcElement.value;
    }
    else {
      console.log("please select respected checkbox")
    }
  }

  scheduleBill(order) {
    let prodArray = [];
    this.disableScheduleButton = true;
    this.schedulebillProductArray.forEach(prod => {
      delete prod.isScheduleBillButtonDisable;
      delete prod.isWarningQuantity;
    })
    prodArray = this.schedulebillProductArray.filter(prod => prod.productQuantity > 0);
    let billObject = { orderUniqueId: '', orderInvoiceNumber: '', orderInvoiceID: '', productDeliveries: [] };
    billObject.orderUniqueId = order.orderInfo.orderUniqueId;
    billObject.orderInvoiceNumber = order.orderInfo.orderInvoiceNumber;
    billObject.orderInvoiceID = order.orderInfo.orderInvoiceID;
    billObject.productDeliveries = prodArray;
    console.log(billObject);
    this.orderService.splitOrder(billObject).subscribe(res => {
      this.schedulebillProductArray = [];
      billObject = { orderUniqueId: '', orderInvoiceNumber: '', orderInvoiceID: '', productDeliveries: [] }
      prodArray = [];
      this.notifierService.notify("success", "Bill Scheduled Successfully.");
      this.searchData(this.searchText, this.searchOption);
    }, Error => {
      console.log(Error);
      this.schedulebillProductArray = [];
      this.notifierService.notify("error", "Error In Scheduling Bill.");
      this.searchData(this.searchText, this.searchOption);
    })
  }

  openOrder(order) {
    order.prodQList.forEach(product => {
      product.value1 = 0;
      product.value2 = 0;
      product.value3 = 0;
      product.isWarningQuantity = false;
      product.isScheduleBillButtonDisable = false;
      product.isDeliveryFromWarehouse = false;
      product.isCustomerPickup = false;
      product.isDeliveryFromStore = false;
      if (order.orderInfo.orderType == 'ORDER_TYPE_DELIVERY') {
        product.isDeliveryFromWarehouse = true;
        product.value1 = product.productQuantity;
      }
      if (order.orderInfo.orderType == 'ORDER_TYPE_STORE_PICKUP') {
        product.value2 = product.productQuantity;
        product.isCustomerPickup = true;
      }
      if (order.orderInfo.orderType == 'ORDER_TYPE_STORE_DELIVERY') {
        product.value3 = product.productQuantity;
        product.isDeliveryFromStore = true;
      }

      product.orderType = order.orderInfo.orderType;
      this.schedulebillProductArray.push({
        orderType: order.orderInfo.orderType,
        productId: product.product.productId,
        productQuantity: product.productQuantity,
        branchName: order.orderInfo.branchName,
        isWarningQuantity: false,
        isScheduleBillButtonDisable: false
      })
    });
  }

  closeOrder() {
    this.schedulebillProductArray = [];
    this.isScheduleBillButtonDisable = false;
    this.isWarningQuantity = false;
  }

  changeState(order) {
    this.orderService.orderUpdateBajaj(order).subscribe(() => {
      this.notifierService.notify("success", "Order Updated Successfully");
      this.ngOnInit();
    }, error => {
      this.notifierService.notify("error", error.error.Result);
    });
  }
}